export const production = true

const PROD = 'https://connect-platform-api.loyal.id/api/v1/'
const DEV = 'https://sandbox-api.loyal.id/api/v1/'

const SUBSCRIBE_PROD = 'https://partner-api-srv.e-supplybox.id/'
const SUBSCRIBE_DEV = 'https://supplybox-partner-api-dev.smartsistem.id/'

export const BASE_URL = production ? PROD : DEV
export const SUBSCRIBE_URL = production ? SUBSCRIBE_PROD : SUBSCRIBE_DEV
export const CLIENT_CODE = production ? '280801' : '270801'
export const SECRET_CODE = '6LcMGjEUAAAAAH_TT2w_wfBCP9tYzuA3csPzp2wN'